export interface AuthPort {
  getToken(): string | null
  setToken(token: string): void
  onRefreshFailed(): void
}

let authPort: AuthPort | null = null

export function setAuthPort(port: AuthPort): void {
  authPort = port
}

export function getAuthPort(): AuthPort {
  if (!authPort) {
    throw new Error('Auth port is not configured. Call configureAuthTransport() during app bootstrap.')
  }
  return authPort
}

export function tryGetAuthPort(): AuthPort | null {
  return authPort
}

/** Test-only: drop transport binding between cases. */
export function clearAuthPortForTests(): void {
  authPort = null
}
